/**
 * Enums for automation module
 */

export enum AutomationStepExecutionStatus {
	PENDING = 'pending',
	DISPATCHED = 'dispatched',
	PROCESSING = 'processing',
	PROCESSING_PARALLEL = 'processing_parallel',
	COMPLETED = 'completed',
	FAILED = 'failed',
	SKIPPED = 'skipped',
	WAITING = 'waiting',
	WAITING_FOR_EVENT = 'waiting_for_event',
}

export enum AutomationExecutionStatus {
	PENDING = 'pending',
	RUNNING = 'running',
	COMPLETED = 'completed',
	FAILED = 'failed',
	CANCELLED = 'cancelled',
}

export enum AutomationFlowStatus {
	DRAFT = 'draft',
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	ARCHIVED = 'archived',
}

export enum AutomationTriggerType {
	MANUAL = 'manual',
	SCHEDULE = 'schedule',
	EVENT = 'event',
	WEBHOOK = 'webhook',
}

export enum AutomationStepType {
	START = 'start',
	ACTION = 'action',
	CONDITION = 'condition',
	DELAY = 'delay',
	END = 'end',
	BULK_INDEX_CLIENT_BATCH = 'bulk_index_client_batch',
	BULK_INDEX_ITEM_BATCH = 'bulk_index_item_batch',
}
